export default {
	wxLogin: 'v1.0/cust/trust-login',	//微信登陆
	wxBindMobile: 'v1.0/cust/bind-mobile-wx',	//微信绑定手机号
	getAds: 'v1.0/ads',		//首页轮播广告
	getAgreement: 'v1.0/cust/user-print-agreement',	//获取协议
	updateUserInfo: 'v1.0/cust/modify-info',	//修改用户信息
	sendCode: 'v1.0/verify-code/send',	//发送验证码
	validate: 'v1.0/cust/bind-mobile',	//验证 码
	loginQrCode: 'v1.0/cust/login-wxqrcode',	//登陆二维码
	
	getUpLoadInfo: 'v1.0/files/upload-info',	//获取上传前token和url
	addOrder: 'v1.0/orders',		//生成订单
	getOrderFee: 'v1.0/orders/cal-fee',		//获取订单费用
	pay:	'v1.0/pay',		//预支付接口
	getOrderStatus: 'v1.0/orders/state',	//获取订单状态
	addRechargeOrder: 'v1.0/recharges/order',	//充值下单
	getRechargeRule: '/v1.0/recharges/rules',	//获取充值规则
	addCarts: 'v1.0/carts/add', //添加购物车
	myCarts: 'v1.0/carts/my-cart',	//我的购物车
	delCarts: 'v1.0/carts/del',	//删除购物车
	cancalPay: 'v1.0/frontlogs',	//支付取消上报
	
	getNearbyStations : 'v1.0/stations/nearby',	//获取附近设备
	getStationByDevId: 'v1.0/stations/info-by-devid',	//根据设备id获取打印站点
	getCustomInfo: 'v1.0/cust/info',	//获取用户信息
	getAccountDetail: 'v1.0/cust/acc-detail',	//账单明细
	getMyOrder: 'v1.0/orders/my-order',	//订单列表
	getOrderDetail: 'v1.0/orders/detail',	//订单详情
	orderReturn: 'v1.0/orders/return', //退款
	
	getShareSummary: 'v1.0/cust/promotion-summary',	//个人分享统计
	getShareRank: 'v1.0/cust/promotion-reward-rank',	//分享排名
	getShareCust: '/v1.0/cust/promotion-invitation-cust',	//所有个人分享用户
	
	
	addDocs: 'v1.0/docs/add',
	myDocStat: 'v1.0/docs/my-doc-stat',
	getDocsClass: 'v1.0/docs/class',	//分类
	
	wenkuBalance : 'v1.0/cust/wenku-balance',	//文库余额查询
	browseDocs: 'v1.0/docs/browse',	//文库文档详情
	searchDocs: 'v1.0/docs/search',
	docsState: 'v1.0/docs/state',//修改文库状态
	docsDelete: 'v1.0/docs/delete',
	docsPrice: 'v1.0/docs/change-price',
	//pc端相关
	validatePC: 'v1.0/cust/validate-userinfo-pass', //验证用户信息完成
	
	question:'v1.0/cust-service/add-question',
}